import React from 'react';
import { authHelper } from '../../../../../base/infrastructure/helpers';
import { Navigate } from 'react-router-dom';

export function NoAuthRouterProtector({ children }: { children: JSX.Element }) {
  const account = authHelper.getAccount();
  if (account) return <Navigate to={'/'} replace />;
  return <div>{children}</div>;
}
